import { cn } from "@/lib/utils";

interface TypingIndicatorProps {
  className?: string;
}

/**
 * Three soft dots — the AI is thinking.
 * No container, no bubble. Just dots floating in space.
 */
export function TypingIndicator({ className }: TypingIndicatorProps) {
  return (
    <div className={cn("flex items-center gap-1.5 px-1 py-2 animate-fade-in", className)}>
      <span className="typing-dot" />
      <span className="typing-dot [animation-delay:150ms]" />
      <span className="typing-dot [animation-delay:300ms]" />
    </div>
  );
}
